<template>
    <vue-select :list="rangeOptions" v-model="selectedRange" class="w-full sm:w-2/12"></vue-select>
</template>

<script>
import VueSelect from "@/scripts/components/app/common/VueSelect.vue";
import {mapActions, mapState} from "pinia";
import {DashboardRangeStore} from "@/scripts/store/dashboard_range.store";

export default {
    components: {VueSelect},
    data() {

    },

    computed: {
        ...mapState(DashboardRangeStore, ['rangeOptions', "currentRange"]),
        selectedRange: {
            get() {
                return this.currentRange
            },
            set(val) {
                this.updateCurrentRange(val)
            }
        }
    },

    methods: {
        ...mapActions(DashboardRangeStore, ['updateCurrentRange'])
    }
}
</script>

<style scoped>

</style>
